import { useContext, useState } from 'react';
import ConfirmActionModal from '../../ConfirmActionModal';
import { Switch } from '../../Input/Input';
import { StoreContext } from '../../Store';
import { QAStoreContext } from '../QAChecklistTab/QAStore';
import {
  directionAllowsMultipleConsignors,
  directionAllowsMultipleInvoices,
  isLoadTypeEPO,
  isLoadStatusSubmitted,
} from '../../../utils/unifiedLoads';

const LoadInfoHeader = ({ spreadsheetHandle, togglesDisabled }) => {
  const {
    multipleConsignors,
    multipleInvoices,
    directionSelected,
    validatedRowsReadyToSubmit,
    newLoadItemsModified,
    newLoadParent,
    loadStatus,
    loadTypeDescription,
    consignor,
    invoicenumber,
    newLoadDataModified,
    clientIDname,
    clientIDEori,
  } = useContext(StoreContext);

  const qaStore = useContext(QAStoreContext);
  const unifiedLoadDataState = qaStore?.unifiedLoadData?.[0] ?? {};

  const isEPOLoad = isLoadTypeEPO(unifiedLoadDataState?.Headers);
  const portalRef = unifiedLoadDataState?.Headers?.[0]?.portalRef ?? '';
  const clientName = unifiedLoadDataState?.Headers?.[0]?.customerName ?? '';
  const eoriNumber = unifiedLoadDataState?.Headers?.[0]?.eoriNumber ?? '';

  const setNewLoadDataModified = newLoadDataModified[1];

  const [confirmationModalType, setConfirmationModalType] = useState(null);
  const currentDirection = directionSelected[0];
  const allowsMultipleConsignors = directionAllowsMultipleConsignors(currentDirection);
  const allowsMultipleInvoices = directionAllowsMultipleInvoices(currentDirection);

  const hasUpdatedItems = newLoadItemsModified[0] || validatedRowsReadyToSubmit[0].length > 0;

  const handleMultipleConsignorsClick = () => {
    //If we are turning ON multiple consignors
    if (!multipleConsignors[0]) {
      consignor[1]('');
      setNewLoadDataModified(true);
    }

    if (hasUpdatedItems && multipleConsignors[0]) {
      setConfirmationModalType('consignors');
    } else {
      multipleConsignors[1]((prev) => {
        //If we are turning ON multiple consignors
        if (!prev) {
          multipleInvoices[1](true);
          invoicenumber[1]('');
        }
        return !prev;
      });
    }
  };

  const handleMultipleInvoicesClick = () => {
    //If we are turning ON multiple invoices
    if (!multipleInvoices[0]) {
      invoicenumber[1]('');
      setNewLoadDataModified(true);
    }

    if (hasUpdatedItems && multipleInvoices[0]) {
      setConfirmationModalType('invoices');
    } else {
      multipleInvoices[1]((prev) => {
        //If we are turning OFF multiple invoices
        if (prev) {
          multipleConsignors[1](false);
        }
        return !prev;
      });
    }
  };

  const handleModalConfirm = () => {
    multipleInvoices[1](false);
    multipleConsignors[1](false);

    spreadsheetHandle.current.excelDispatch({ type: 'reset' });
    setConfirmationModalType(null);
  };

  const isParentEori =
    isEPOLoad && isLoadStatusSubmitted(unifiedLoadDataState?.Headers?.[0]?.loadstatus) ? 'EORI' : null;

  return (
    <div className="pt-2 ps-2 h-unset d-flex justify-content-between">
      <ConfirmActionModal
        title="Warning"
        message="By continuing all item data will be lost"
        show={confirmationModalType}
        onClose={() => setConfirmationModalType(null)}
        onConfirm={handleModalConfirm}
        warning
      />
      <div>
        <h2 className="m-0 p-0 floating-box-header-general">
          {isEPOLoad ? `Reference No: ${portalRef}` : 'CABIE Load Information'}
        </h2>
        <div className="d-flex pt-1">
          <Switch
            checked={multipleConsignors[0]}
            onChange={handleMultipleConsignorsClick}
            name={'multipleConsignors'}
            className=""
            disabled={togglesDisabled || !allowsMultipleConsignors || loadTypeDescription[0] === 'CM8-Draft'}
            data-testid="multipleConsignors-slider"
          />
          <p className="ps-2 mb-0 cabie-company-info">Multiple consignors</p>
        </div>

        <div>
          <div className="d-flex pt-1 pb-0">
            <Switch
              checked={multipleInvoices[0]}
              onChange={handleMultipleInvoicesClick}
              name={'multipleInvoices'}
              className=""
              disabled={togglesDisabled || !allowsMultipleInvoices || loadTypeDescription[0] === 'CM8-Draft'}
              data-testid="multipleInvoices-slider"
            />
            <p className="ps-2 cabie-company-info">Multiple Invoices</p>
          </div>
        </div>
      </div>
      <div className="pe-3">
        <div className="row pe-3">
          <div className="col cabie-company-info cci-header">
            <p className="mb-0 text-nowrap">Parent</p>
            <p className="mb-0 text-nowrap">Customer Name</p>
            <p className="mb-0 text-nowrap">EORI Number</p>
            <p className="mb-0 text-nowrap">Status</p>
          </div>
          <div className="col cabie-company-info">
            <p className="mb-0 text-nowrap">{newLoadParent[0].parentName || isParentEori || 'No Parent Selected'}</p>
            <p className="mb-0 text-nowrap">{clientName || clientIDname[0] || '-'}</p>
            <p className="mb-0 text-nowrap">{eoriNumber || clientIDEori[0] || '-'}</p>
            <p className="mb-0 text-nowrap">{loadStatus[0] || 'New'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadInfoHeader;
